"use strict";

var socialShare = function socialShare(url, title) {
  if (typeof window !== "undefined") {
    var sw = screen.availWidth || 1024;
    var sh = screen.availHeight || 700;
    var pw = Math.min(600, sw - 40);
    var ph = Math.min(600, sh - 40);
    var px = Math.floor((sw - pw) / 2);
    var py = Math.floor((sh - ph) / 2);
    window.open(url, "Share ".concat(title), "width=".concat(pw, ",height=").concat(ph, ",left=").concat(px, ",top=").concat(py, ",location=0,menubar=0,toolbar=0,personalbar=0,status=0,scrollbars=1,resizable=1"));
  }
};